var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"circle",class:_vm.colorClass}),_c('span',{staticClass:"ml04"},[_vm._v(_vm._s(_vm.statusNameFinal))]),(_vm.isShowPercentage)?_c('span',{staticClass:"ml04"},[_vm._v(_vm._s(_vm.percentageShow))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }